export default [
	{
		start: 0.05,
		end: 2,
		text: 'Hive, toujours là pour vous.'
	}
]
